<template>
	<div id="login">            
        <hr class="path ml-5 hide-on-mobile">
        <form class="m-center w-center mx-auto w-m-80 w-30" action="login.php">                
            <img src="img/reset_password.png" alt="Bisa Cek" class="mx-auto d-block mb-5 img-fluid">
            Password Anda berhasil dipulihkan silahkan masuk kembali
            <div class="row mt-4">
                <router-link tag="button" to="login" class="col btn btn-secondary pd-10-20" type="submit">Kembali Masuk</router-link>
            </div>
        </form>           
    </div>
</template>

<script>
export default {
	name: 'SuccessResetPassword'
}
</script>